module.exports = __webpack_public_path__ + "img/15.4253b301.png";